import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { HiChevronDown } from '@react-icons/all-files/hi/HiChevronDown';
import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';
import { RiCloseCircleFill } from '@react-icons/all-files/ri/RiCloseCircleFill';
import { RiDeleteBinLine } from '@react-icons/all-files/ri/RiDeleteBinLine';
import { RiFileCopyLine } from '@react-icons/all-files/ri/RiFileCopyLine';
import { RiShapeLine } from '@react-icons/all-files/ri/RiShapeLine';
import { useContextSelector } from 'use-context-selector';
import { cloneNodeCommand, removeNodeCommand, createNodeCommand } from '../../commands/node.js';
import { findAncestorNodes } from '../../utils/node.js';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../contexts/internal/EditorContext.js';
import { useEditorNode } from '../../hooks/useEditorNode.js';
import { COLORS } from '../../styles/colors.js';
import 'qs';
import 'query-string';
import Toolbar from '../Toolbar/Toolbar.js';
import Draggable from './Draggable.js';
import { Item, ItemRow, IconButton, Icon, Label, SubList } from './TreeList.style.js';

function TreeListItemImpl(_ref) {
  var _Component$renderIcon2, _Component$renderTitl2, _Component$allowedChi;
  var node = _ref.node,
    path = _ref.path,
    isParentSelected = _ref.isParentSelected,
    isParentDisabled = _ref.isParentDisabled;
  var _useContextSelector = useContextSelector(EditorContext, function (context) {
      return context;
    }),
    components = _useContextSelector.components,
    dispatch = _useContextSelector.dispatch,
    getState = _useContextSelector.getState;
  var Component = components[node.type];
  var _getState = getState(),
    document = _getState.document;
  var _useEditorNode = useEditorNode(path),
    isSelected = _useEditorNode.isSelected,
    onSelect = _useEditorNode.onSelect,
    isHovered = _useEditorNode.isHovered,
    onHover = _useEditorNode.onHover,
    onUnhover = _useEditorNode.onUnhover;
  function selectItem(e) {
    e.stopPropagation();
    onSelect();
  }
  function handleFocus(e) {
    e.stopPropagation();
    if (isHovered) {
      return;
    }
    onHover(path);
  }
  function handleBlur() {
    onUnhover();
  }
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  function toggleExpand() {
    setExpanded(function (e) {
      return !e;
    });
  }
  function cloneItem(e) {
    e.stopPropagation();
    dispatch(cloneNodeCommand(path));
  }
  function deleteItem(e) {
    e.stopPropagation();
    dispatch(removeNodeCommand(path));
  }
  function insertItem(type) {
    dispatch(createNodeCommand(type, [].concat(_toConsumableArray(path), [node.children.length])));
  }

  /**
   * 지원하지 않는 컴포넌트
   */
  if (!Component) {
    return jsx(Item, {
      style: {
        cursor: 'default'
      }
    }, jsx(ItemRow, null, jsx(IconButton, {
      type: "button",
      width: 12,
      style: {
        marginRight: '6px'
      },
      title: isExpanded ? '펼치기' : '접기',
      hidden: !node.children.length,
      onClick: toggleExpand
    }, isExpanded ? jsx(HiChevronDown, null) : jsx(HiChevronRight, null)), jsx(Icon, null, jsx(RiCloseCircleFill, {
      style: {
        color: 'red'
      }
    })), jsx(Label, {
      error: true,
      "data-error": "Unsupported"
    }, node.type), jsx(IconButton, {
      type: "button",
      title: "\uC0AD\uC81C",
      onClick: deleteItem
    }, jsx(RiDeleteBinLine, null))), isExpanded && jsx(SubList, null, node.children.map(function (child, i) {
      var _child$key;
      return jsx(TreeListItem, {
        key: (_child$key = child.key) !== null && _child$key !== void 0 ? _child$key : i,
        node: child,
        path: [].concat(_toConsumableArray(path), [i]),
        isParentDisabled: true
      });
    })));
  }

  /**
   * 지원하지 않는 컴포넌트의 자식
   */
  if (isParentDisabled) {
    var _Component$renderIcon, _Component$renderTitl;
    return jsx(Item, {
      style: {
        cursor: 'default',
        color: '#b5bbc1'
      }
    }, jsx(ItemRow, null, jsx(IconButton, {
      type: "button",
      width: 12,
      style: {
        marginRight: '6px'
      },
      title: isExpanded ? '펼치기' : '접기',
      hidden: !node.children.length,
      onClick: toggleExpand
    }, isExpanded ? jsx(HiChevronDown, null) : jsx(HiChevronRight, null)), jsx(Icon, null, ((_Component$renderIcon = Component.renderIcon) === null || _Component$renderIcon === void 0 ? void 0 : _Component$renderIcon.call(Component, node.props)) || jsx(RiShapeLine, null)), jsx(Label, {
      lineThrough: true
    }, ((_Component$renderTitl = Component.renderTitle) === null || _Component$renderTitl === void 0 ? void 0 : _Component$renderTitl.call(Component, node.props)) || Component.label)), isExpanded && jsx(SubList, null, node.children.map(function (child, i) {
      var _child$key2;
      return jsx(TreeListItem, {
        key: (_child$key2 = child.key) !== null && _child$key2 !== void 0 ? _child$key2 : i,
        node: child,
        path: [].concat(_toConsumableArray(path), [i]),
        isParentDisabled: true
      });
    })));
  }
  return jsx(Item, {
    isSelected: isSelected,
    onClick: selectItem,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur
  }, jsx(Draggable, {
    path: path,
    disabled: Component.disabledMove
  }, jsx(ItemRow, {
    hasBorder: isHovered
  }, jsx(IconButton, {
    type: "button",
    width: 12,
    style: {
      marginRight: '6px'
    },
    title: isExpanded ? '펼치기' : '접기',
    hidden: !node.children.length,
    onClick: toggleExpand
  }, isExpanded ? jsx(HiChevronDown, {
    color: isSelected ? COLORS.blue60 : undefined
  }) : jsx(HiChevronRight, null)), jsx(Icon, null, ((_Component$renderIcon2 = Component.renderIcon) === null || _Component$renderIcon2 === void 0 ? void 0 : _Component$renderIcon2.call(Component, node.props)) || jsx(RiShapeLine, null)), jsx(Label, {
    bold: isSelected
  }, ((_Component$renderTitl2 = Component.renderTitle) === null || _Component$renderTitl2 === void 0 ? void 0 : _Component$renderTitl2.call(Component, node.props)) || Component.label || node.type), !Component.disabledClone && jsx(IconButton, {
    type: "button",
    title: "\uBCF5\uC81C",
    hidden: !isHovered,
    onClick: cloneItem
  }, jsx(RiFileCopyLine, null)), !Component.disabledDelete && jsx(IconButton, {
    type: "button",
    title: "\uC0AD\uC81C",
    hidden: !isHovered,
    onClick: deleteItem
  }, jsx(RiDeleteBinLine, null))), isExpanded && jsx(SubList, {
    hasLeftBorder: isSelected || isParentSelected
  }, node.children.map(function (child, i) {
    var _child$key3;
    return jsx(TreeListItem, {
      key: (_child$key3 = child.key) !== null && _child$key3 !== void 0 ? _child$key3 : i,
      node: child,
      path: [].concat(_toConsumableArray(path), [i]),
      isParentSelected: isSelected || isParentSelected
    });
  }))), isSelected && jsx(Toolbar, {
    tools: ((_Component$allowedChi = Component.allowedChildren) !== null && _Component$allowedChi !== void 0 ? _Component$allowedChi : Object.keys(components)).filter(function (child) {
      var _childComponent$disal;
      var childComponent = components[child];
      var ancestors = findAncestorNodes(document, path).map(function (_ref2) {
        var type = _ref2.type;
        return type;
      });
      var hasDisallowedAncestors = ((_childComponent$disal = childComponent === null || childComponent === void 0 ? void 0 : childComponent.disallowedAncestors) !== null && _childComponent$disal !== void 0 ? _childComponent$disal : []).some(function (a) {
        return ancestors.indexOf(a) !== -1;
      });
      return !hasDisallowedAncestors && ((childComponent === null || childComponent === void 0 ? void 0 : childComponent.allowedParent) == null || childComponent.allowedParent.includes(node.type));
    }),
    onSelect: insertItem
  }));
}
var TreeListItem = /*#__PURE__*/React__default.memo(TreeListItemImpl);

export { TreeListItem };
//# sourceMappingURL=TreeListItem.js.map
